module.exports = __webpack_public_path__ + "static/media/Sharp-LS012B7DD06A-Mechanical-Drawing.694885fb.png";